export default "__VITE_ASSET__eaf7da29__"